import request from "../utils/request";
import store from "@/store/store";

export async function getBranchList(payload) {
  return request.get("Branch/List", {
    params: {
      code: payload.branchCode,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      cityId: payload.city != null ? payload.city.id : null,
      stateId: payload.state != null ? payload.state.id : null,
      email: payload.branchEmail,
      phoneNumber: payload.branchPhoneNumber,
      address: payload.branchAddress,
      startTime: null,
      endTime: null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      active: payload.active,
    }
  });
}

export async function getBranchListForDealer(payload) {
  return request.get("Branch/ListForDealer", {
    params: {
      code: payload.branchCode,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      cityId: payload.city != null ? payload.city.id : null,
      stateId: payload.state != null ? payload.state.id : null,
      email: payload.branchEmail,
      phoneNumber: payload.branchPhoneNumber,
      address: payload.branchAddress,
      startTime: null,
      endTime: null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      active: payload.active,
    }
  });
}

export async function getExcel(payload) {
  return request.get("Branch/GetExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      code: payload.branchCode,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      cityId: payload.city != null ? payload.city.id : null,
      stateId: payload.state != null ? payload.state.id : null,
      email: payload.branchEmail,
      phoneNumber: payload.branchPhoneNumber,
      address: payload.branchAddress,
      startTime: null,
      endTime: null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  })
}

export async function getExcelForDealer(payload) {
  return request.get("Branch/GetExcelForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      code: payload.branchCode,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      cityId: payload.city != null ? payload.city.id : null,
      stateId: payload.state != null ? payload.state.id : null,
      email: payload.branchEmail,
      phoneNumber: payload.branchPhoneNumber,
      address: payload.branchAddress,
      startTime: null,
      endTime: null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  })
}

export async function checkNewBranchName(newBranchName, id) {
  return request.get("Branch/CheckNewBranchName?branchName=" + newBranchName + "&id=" + id);
}

export async function checkNewBranchCode(newBranchCode, id) {
  return request.get("Branch/CheckNewBranchCode?branchCode=" + newBranchCode + "&id=" + id);
}

export async function getBranchOwnerList() {
  return request.get("Branch/BranchOwnerList");
}

export async function syncStocks(branchId) {
  if(branchId) {
    return request.post("Branch/SyncStocks?branchId=" + branchId)
  } else {
    return request.post("Branch/SyncStocks")
  }

}

export async function getStateList(cityId) {
  return request.get("Branch/StateList?cityId=" + cityId);
}

export async function getFullAdressFromMap(payload) {
  return request.get("Branch/GetFullAddress", {
    params: {
      lat: payload.lat,
      lng: payload.lng
    }
  });
}

const apiKey = "AIzaSyDydu6rFh8JYCemG3Yn1Irv7zHGAtCKvg8";

export async function getCityList() {
  return request.get("Branch/CityList");
}

export async function getCityNameList2() {
  return new Promise((resolve, reject) => {
    let cityNameListGetter = store.getters["getCityNameList"]
    if (cityNameListGetter.length > 0) {
      resolve(cityNameListGetter);
    } else {
      try {
        return request.get("Branch/CityList").then(res => {
          store.dispatch("getCityNameList", res.data);
          resolve(res.data);
        });
      } catch (error) {
        reject(error);
      }
    }
  });
}

export async function getBranchNameList2() {
  return new Promise((resolve, reject) => {
    let branchNameListGetter = store.getters["getBranchNameList"]
    if (branchNameListGetter.length > 0) {
      resolve(branchNameListGetter);
    } else {
      try {
        request.get("User/BranchNameList").then(res => {
          store.dispatch("getBranchNameList", res.data);
          resolve(res.data);
        });
      } catch (error) {
        reject(error)
      }
    }
  });
}

export async function getCenterNameList() {
  return request.get("Branch/GetCenterNameList");
}
export async function ChangeIsOnline(payload) {
  return request.put("Branch/is-online", payload);
}
export async function GetIsOnline() {
  return request.get("Branch/is-online");
}
export async function createNewBranch(newBranch) {
  return request.post("Branch/Create", newBranch);
}
export async function updateBranch(branch) {
  return request.post("Branch/Update", branch);
}
export async function deleteBranch(id) {
  return request.delete('Branch/Delete?id=' + id);
}
export async function resetBranch(id) {
  return request.post('Branch/ResetStocks?id=' + id);
}

export async function currentBranch() {
  return request.get("Branch/current");
}
export async function uploadImage(image) {
  return request({
    method: 'post',
    url: 'UploadImage/',
    data: image,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  });
}

export async function setQrMenuSetting(branchSetting) {
  return request.post('Branch/qr-menu', branchSetting);
}

function serialize(obj, prefix) {
  let str = [],
    p;
  for (p in obj) {
    if (obj[p] == null) obj[p] = "";
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}
